export default __webpack_public_path__ + "static/media/photo--sm--justin.a8993556.jpg";